.tab_border_radius {
  border-radius: 10px !important;
}

.tab_margin {
  margin-bottom: 14px;
}
